<template>
<div class="chapter">
<div class="inner_page">
<p class="C186"><a id="page_v">CONTENTS</a></p><a id="page_v">
</a><p class="C188"><a id="page_v"><em></em></a><em><a href="#/xhtml/05_Acknowle#page_vii">Acknowledgments</a></em></p>
<p class="C189"><em><a href="#/xhtml/06_Introduc#page_1">Introduction</a></em></p>
<p class="C188"><a href="#/xhtml/07_One___Co#page_11">ONE. “Convenient to the New York Market”: Feeding New York City in the Early National Period, 1786–1830</a></p>
<p class="C188"><span href="#/xhtml/08_Two____T#page_39" title="Link target outside of Sample">TWO. “The Glory of a Plenteous Land”: The Transformation of New York’s Food Supply, 1825–1865</span></p>
<p class="C188"><span href="#/xhtml/09_Three___#page_73" title="Link target outside of Sample">THREE. “Monuments of Municipal Malfeasance”: The Flip Side of Dietary Abundance, 1825–1865</span></p>
<p class="C188"><span href="#/xhtml/10_Four___T#page_103" title="Link target outside of Sample">FOUR. “To See and Be Seen”: Restaurants and Public Culture, 1825–1865</span></p>
<p class="C188"><span href="#/xhtml/11_Five___N#page_139" title="Link target outside of Sample">FIVE. “No Place More Attractive than Home”: Domesticity and Consumerism, 1830–1880</span></p>
<p class="C189"><span href="#/xhtml/12_Six___Th#page_169" title="Link target outside of Sample">SIX. “The Empire of Gastronomy”: New York and the World, 1850–1890</span></p>
<p class="C188"><em><span href="#/xhtml/13_Conclusi#page_201" title="Link target outside of Sample">Conclusion. From the Broadway Shambles to New Amsterdam Market</span></em></p>
<p class="C188"><em><span href="#/xhtml/14_Notes#page_209" title="Link target outside of Sample">Notes</span></em></p>
<p class="C188"><em><span href="#/xhtml/15_Index#page_253" title="Link target outside of Sample">Index</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?209be0a6